import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { get, getUserIdFromToken } from 'api';
import moment from 'moment';

const PartnerMatches = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [upcomingMatches, setUpcomingMatches] = useState([]);

  const isChallenger = (item) => {
    return item.challenger_id === getUserIdFromToken();
  };

  const fetchUpcomingMatches = async () => {
    try {
      const response = await get('/matches/upcoming-matches');
      const data = await response.json();
      setUpcomingMatches(data);
    } catch (error) {
      console.error('Failed to fetch matches:', error);
    }
  };

  useEffect(() => {
    fetchUpcomingMatches();
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        display: upcomingMatches.length > 0 ? 'flex' : 'none',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="body3"
        color={theme.palette.darkGrey[500]}
        fontWeight={600}
        marginBottom={'8px'}
        marginTop={'16px'}
      >
        {t('tennisPartnerMatches')}:
      </Typography>
      <Box
        sx={{
          maxHeight: '456px',
          overflowY: 'auto',
          overflowX: 'hidden',
          marginRight: '-8px',
          '::-webkit-scrollbar': {
            width: '4px',
            borderRadius: '8px',
            background: theme.palette.darkGrey[200],
          },
          '&::-webkit-scrollbar-thumb': {
            background: theme.palette.darkGrey[300],
            borderRadius: '8px',
            minHeight: '24px',
          },
        }}
      >
        {upcomingMatches.length > 0 &&
          upcomingMatches.map((match, index) => {
            const timeMatch = moment(match.match_time, 'HH:mm:ss');
            const [hours, minutes] = match.match_length.split(':').map(Number);
            const updatedTime = timeMatch
              .clone()
              .add(hours, 'hours')
              .add(minutes, 'minutes');

            // Format the times as strings
            const formattedTimeMatch = timeMatch.format('HH:mm'); // e.g., "13:00"
            const formattedUpdatedTime = updatedTime.format('HH:mm'); // e.g., "15:00"

            return (
              <Box
                key={index}
                sx={{
                  width: '224px',
                  padding: '16px',
                  backgroundColor: theme.palette.base.white,
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <Typography
                  variant="body3"
                  color={theme.palette.darkGrey[700]}
                  fontWeight={600}
                >
                  {t('date')}: {match.match_date}
                </Typography>
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[600]}
                  fontWeight={400}
                >
                  {t('time')}: {formattedTimeMatch} - {formattedUpdatedTime}
                </Typography>
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[600]}
                  fontWeight={400}
                >
                  {t('location')}: {match.city}
                </Typography>
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[600]}
                  fontWeight={400}
                >
                  {t('court')}: {match.place}
                </Typography>
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[600]}
                  fontWeight={400}
                >
                  {t('level')}: {match.ntrp}
                </Typography>
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[600]}
                  fontWeight={400}
                >
                  {t('players')}: {match.players} / {match.max_players}
                </Typography>
                {/* <Box
                sx={{
                  marginTop: '16px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate(`/siusti-zinute`, {
                    state: {
                      isTournament: true,
                      isMulti: false,
                      mailTo: isChallenger(match)
                        ? match.opponent_email
                        : match.challenger_email,
                      mailSubject: `Padelio Partneris - susitikimas ${match.match_date}`,
                      location: match.city,
                      avatar: isChallenger(match)
                        ? match.opponent_image
                        : match.challenger_image,
                      name: isChallenger(match)
                        ? match.opponent_full_name
                        : match.challenger_full_name,
                    },
                  });
                }}
              >
                <Typography
                  variant="body4"
                  color={theme.palette.darkGrey[700]}
                  fontWeight={600}
                >
                  {t('sendMessage')}
                </Typography>
              </Box> */}
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};

export default PartnerMatches;
